module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', {
    staticClass: "bg-gray-100 min-h-screen flex flex-col list-bouteilles",
    attrs: {
      "id": "bottle_page"
    }
  }, [_c('div', {
    staticClass: "bg-gradient-to-b from-secondary to-primary"
  }, [_c('div', {
    staticClass: "p-2 space-y-3"
  }, [_c('app-header', {
    staticClass: "text-white",
    attrs: {
      "icon": "bouteille"
    }
  }, [_c('div', {
    staticClass: "flex items-center justify-between"
  }, [_c('h1', {
    staticClass: "text-2xl font-semibold tracking-wide"
  }, [_vm._v("Bouteille")])])]), _vm._v(" "), _c('action-bar', {
    staticClass: "!p-0 !m-0",
    attrs: {
      "back": {
        name: 'liste-bouteilles'
      }
    }
  }, [(!this.isRestit && this.bouteille.actif === true) ? _c('a', {
    staticClass: "inline-flex items-center gap-2 bg-white text-primary text-sm font-medium px-4 py-2 rounded-lg shadow-sm hover:shadow transition main-action cloturer",
    attrs: {
      "href": "javascript: void 0"
    },
    on: {
      "click": _vm.modifBouteilleStatus
    }
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-otag bg-primary"
  }), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Clôturer")]), _vm._v(" la bouteille\n                    ")])]) : _vm._e(), _vm._v(" "), (!this.isRestit && this.bouteille.actif === false) ? _c('a', {
    staticClass: "inline-flex items-center gap-2 bg-white text-primary text-sm font-medium px-4 py-2 rounded-lg shadow-sm hover:shadow transition main-action rendre",
    attrs: {
      "href": "javascript: void 0"
    },
    on: {
      "click": _vm.modifBouteilleStatus
    }
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-otag bg-primary"
  }), _vm._v(" "), _c('span', [_c('strong', [_vm._v("Rendre")]), _vm._v(" la bouteille\n                    ")])]) : _vm._e()]), _vm._v(" "), _c('section', {
    staticClass: "px-8 pb-15"
  }, [_c('div', {
    staticClass: "flex flex-col md:flex-row items-start md:items-center gap-1 "
  }, [(this.bouteille.favori !== null && this.bouteille.favori !== undefined && this.bouteille.favori.id === _vm.$user.id) ? _c('p', [_c('i', {
    staticClass: "inline-block h-6 w-6 bg-[#f9d342] mask mask-star"
  })]) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "text-4xl font-bold text-gris-bleu whitespace-nowrap"
  }, [(_vm.bouteille.nom) ? _c('span', {
    attrs: {
      "id": "nombouteille"
    }
  }, [_vm._v(_vm._s(_vm.bouteille.nom.nom))]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "text-gray-400 text-lg font-bold md:ml-2 whitespace-nowrap",
    attrs: {
      "id": "poidsmax",
      "data-max": "10"
    }
  }, [_vm._v("\n                        ( " + _vm._s(_vm.bouteille.poids_max) + " Kg )\n                    ")])]), _vm._v(" "), _c('small', {
    staticClass: "text-gray-300 text-lg",
    attrs: {
      "id": "typebouteille"
    }
  }, [_vm._v(_vm._s(_vm.bouteille.type))]), _vm._v(" "), (_vm.bouteille.fournisseur) ? _c('p', {
    staticClass: "text-xl text-white uppercase mb-4",
    attrs: {
      "id": "distributeur"
    }
  }, [_vm._v(_vm._s(_vm.bouteille.fournisseur.nom))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex flex-wrap items-center gap-4 pb-6 w-[70%]"
  }, [(_vm.bouteille.fluide) ? _c('div', {
    staticClass: "flex-none flex items-center gap-2 px-3 py-1 rounded-xl text-white text-md font-medium",
    class: _vm.bouteille.type === 'Fluide frigorigène' ? 'bg-gaz-ff' : (_vm.bouteille.type === 'Récupération' ? 'bg-gaz-rec' : 'bg-gaz-tf')
  }, [_c('div', {
    staticClass: "relative flex items-center"
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 bg-white mask mask-snow"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.bouteille.fluide.nom))]), _vm._v(" "), (_vm.bouteille.fluide.regenerated) ? _c('span', {
    staticClass: "inline-block h-4 w-4 rounded-full bg-warning ml-1",
    attrs: {
      "title": "Fluide régénéré"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-none flex items-center gap-2 px-3 py-1 rounded-xl bg-white text-md font-medium",
    class: _vm.bouteille.type === 'Fluide frigorigène' ? 'text-gaz-ff' : (_vm.bouteille.type === 'Récupération' ? 'text-gaz-rec' : 'text-gaz-tf')
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-bouteille",
    class: _vm.bouteille.type === 'Fluide frigorigène' ? 'bg-gaz-ff' : (_vm.bouteille.type === 'Récupération' ? 'bg-gaz-rec' : 'bg-gaz-tf')
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.bouteille.code))])]), _vm._v(" "), (_vm.bouteille.otag) ? _c('div', {
    staticClass: "flex-none flex items-center gap-2 px-3 py-1 rounded-xl bg-white text-md font-medium",
    class: _vm.bouteille.type === 'Fluide frigorigène' ? 'text-gaz-ff' : (_vm.bouteille.type === 'Récupération' ? 'text-gaz-rec' : 'text-gaz-tf')
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-otag",
    class: _vm.bouteille.type === 'Fluide frigorigène' ? 'bg-gaz-ff' : (_vm.bouteille.type === 'Récupération' ? 'bg-gaz-rec' : 'bg-gaz-tf')
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.bouteille.otag))])]) : _vm._e()])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 shadow-xl pb-28",
    attrs: {
      "id": "bouteille"
    }
  }, [_c('div', {
    staticClass: "p-4"
  }, [_c('div', {
    staticClass: "flex items-start justify-between"
  }, [_c('div', {
    staticClass: "space-y-2",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "id": "bottle_infos_left"
    }
  }, [(_vm.bouteille.actif === false) ? _c('div', {
    staticClass: "font-bold text-alert"
  }, [_c('strong', [_vm._v("BOUTEILLE CLOTURÉE")])]) : _vm._e(), _vm._v(" "), (this.isRestit) ? _c('div', {
    staticClass: "font-bold text-alert uppercase"
  }, [_c('strong', [_vm._v("Bouteille restituée")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-5 rounded-xl border shadow-sm bg-white/80 backdrop-blur-sm border-gray-100"
  }, [_c('div', {
    staticClass: "space-y-3"
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('span', {
    staticClass: "text-sm font-medium text-gray-500"
  }, [_vm._v("Poids total de fluide")]), _vm._v(" "), _c('span', {
    staticClass: "text-lg font-semibold text-gray-800"
  }, [_vm._v(_vm._s(_vm.bouteille.poids_net) + "\n                                    Kg")])]), _vm._v(" "), (_vm.bouteille.tare) ? _c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('span', {
    staticClass: "text-sm font-medium text-gray-500"
  }, [_vm._v("Tare")]), _vm._v(" "), _c('span', {
    staticClass: "text-lg font-semibold text-gray-800"
  }, [_vm._v(_vm._s((_vm.bouteille.tare).toFixed(2)) + "\n                                    Kg")])]) : _vm._e(), _vm._v(" "), (_vm.bouteille.tare) ? _c('div', {
    staticClass: "flex justify-between items-center pt-3 border-t border-gray-100"
  }, [_c('span', {
    staticClass: "text-sm font-medium text-secondary"
  }, [_vm._v("Total")]), _vm._v(" "), _c('span', {
    staticClass: "text-xl font-bold text-secondary"
  }, [_vm._v(_vm._s(_vm.getPoidsBrut(_vm.bouteille.tare,
    _vm.bouteille.poids_net)) + " Kg")])]) : _vm._e(), _vm._v(" "), (_vm.bouteille.ref_livraison !== null) ? _c('div', {
    staticClass: "mt-4 pt-3 border-t border-gray-100"
  }, [_c('div', {
    staticClass: "flex justify-between items-center"
  }, [_c('span', {
    staticClass: "text-sm font-medium text-gray-500"
  }, [_vm._v("Référence")]), _vm._v(" "), _c('span', {
    staticClass: "text-lg font-mono font-semibold text-gray-700",
    attrs: {
      "id": "reference"
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.refLivraisonTruncate) + "\n                                    ")])])]) : _vm._e()])]), _vm._v(" "), _c('p', {
    staticClass: "text-lg text-gray-700 mt-4"
  }, [_vm._v("\n                        Retour prévu :\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center gap-2 mb-4"
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-calendar bg-success"
  }), _vm._v(" "), _c('span', {
    staticClass: "font-bold text-secondary",
    attrs: {
      "id": "dateretour"
    }
  }, [_vm._v(" " + _vm._s(_vm._f("dateFormat")(_vm.bouteille.date_retour_prevue)))])]), _vm._v(" "), _c('hr', {
    staticClass: " border-gray-300"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "mt-6 flex flex-col items-start space-y-3 w-full max-w-xs"
  }, [_c('div', {
    staticStyle: {
      "opacity": "0"
    },
    attrs: {
      "id": "showMap"
    }
  }, [_c('div', {
    ref: "displayMap",
    attrs: {
      "id": "displayMap"
    }
  })]), _vm._v(" "), (_vm.bouteille.otag !== null) ? _c('a', {
    staticClass: "inline-flex items-center px-4 py-2 bg-white text-black font-semibold rounded-lg shadow text-lg w-full border border-success localisation",
    attrs: {
      "href": "javascript: void 0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toggleMap($event)
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-map bg-success mr-2"
  }), _vm._v("\n                    Localiser la bouteille\n                ")]) : _vm._e(), _vm._v(" "), (!this.isRestit && this.bouteille.actif === true && this.bouteille.otag === null) ? _c('a', {
    staticClass: "inline-flex items-center px-4 py-2 bg-white text-black font-semibold rounded-lg shadow text-lg w-full otag",
    attrs: {
      "href": ("fi360://scan?success=tryGoTo&bouteille=" + (_vm.bouteille.id))
    }
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-otag bg-success mr-2"
  }), _vm._v(" "), _c('p', [_vm._v("Ajouter une otag")])]) : _vm._e(), _vm._v(" "), (_vm.bouteille.type === 'Fluide frigorigène' && _vm.bouteille.actif === true) ? _c('a', {
    staticClass: "inline-flex items-center px-4 py-2 bg-success text-white font-semibold rounded-lg shadow text-lg w-full",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToRegul($event)
      }
    }
  }, [_c('i', {
    staticClass: "inline-block h-6 w-6 mask mask-reload bg-white mr-2"
  }), _vm._v(" "), _c('span', [_vm._v("Régulariser")])]) : _vm._e(), _vm._v(" "), (!this.bouteille.favori || (this.bouteille.favori && this.bouteille.favori.id !== this.$user.id)) ? _c('div', {
    staticClass: "inline-flex items-center justify-start px-4 py-2 bg-white text-black border border-yellow-400 font-semibold rounded-lg shadow text-lg w-full favori",
    on: {
      "click": _vm.addThisBottleToFavorite
    }
  }, [_c('i', {
    staticClass: "inline-block h-5 w-5 mask mask-star bg-yellow-400 mr-2"
  }), _vm._v(" "), _c('span', [_vm._v("Ajouter aux favoris")])]) : _c('div', {
    staticClass: "inline-flex items-center justify-start px-4 py-2 bg-yellow-400 text-black border border-yellow-400 font-semibold rounded-lg shadow text-lg w-full favori",
    on: {
      "click": _vm.removeThisBottleToFavorite
    }
  }, [_c('i', {
    staticClass: "inline-block h-5 w-5 mask mask-star bg-white mr-2"
  }), _vm._v(" "), _c('span', [_vm._v("Supprimer des favoris")])])]), _vm._v(" "), (_vm.operations.length > 0) ? _c('div', {
    staticClass: "mt-6 bg-white rounded-lg shadow overflow-hidden mb-25"
  }, [_c('h3', {
    staticClass: "text-xl text-secondary font-normal p-3"
  }, [_vm._v("Historique bouteille")]), _vm._v(" "), _c('table', {
    staticClass: "w-full border-collapse"
  }, [_c('tbody', _vm._l((_vm.operations), function(op) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showHistory),
        expression: "showHistory"
      }],
      key: op.id,
      staticClass: "border-y border-gray-200 odd:bg-[#F7F9FC]",
      class: _vm.getOpClass(op.type)
    }, [_c('td', {
      staticClass: "p-2 sm:p-3 text-center align-middle text-xs sm:text-sm",
      class: op.type.includes('Retrait') ? 'text-gris' : 'text-secondary'
    }, [_c('i', {
      staticClass: "block mx-auto h-5 w-5 sm:h-6 sm:w-6 mask mb-0.5",
      class: op.type.includes('Retrait') ? 'bg-gris mask-goutte-moins' : 'bg-secondary mask-goutte-plus'
    }), _vm._v("\n                                " + _vm._s(op.type) + "\n                            ")]), _vm._v(" "), _c('td', {
      staticClass: "p-2 sm:p-3 text-left align-middle text-xs sm:text-sm"
    }, [_c('p', [_vm._v(_vm._s(op.user))]), _vm._v(" "), _c('p', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(_vm._f("dateFormat")(op.date)))])]), _vm._v(" "), _c('td', {
      staticClass: "p-2 sm:p-3 text-right align-middle font-bold text-xs sm:text-sm"
    }, [_vm._v("\n                                " + _vm._s(op.quantite) + " Kg\n                            ")])])
  }), 0)])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8acc71ac","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bouteille/Bouteille.vue
// module id = 1045
// module chunks = 0